import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Label } from '@/components/ui/label';
import { API } from '../../App';

export const WEEKDAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
export const dayLabel = (d) => (d ? d.charAt(0).toUpperCase() + d.slice(1) : '');

// Employee's designated weekly rest day (Employment Act s.59). Empty = company default.
export const RestDaySelect = ({ value, onChange, testId = 'employee-rest-day-select' }) => {
  const [companyDefault, setCompanyDefault] = useState('');
  useEffect(() => {
    axios.get(`${API}/company-settings`).then((res) => setCompanyDefault(res.data?.default_rest_day || '')).catch(() => {});
  }, []);
  return (
  <div>
    <Label>Designated Rest Day</Label>
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className="w-full h-10 rounded-md border border-slate-300 dark:border-slate-600 px-3 bg-white dark:bg-slate-900 dark:text-slate-100"
      data-testid={testId}
    >
      <option value="">Company default{companyDefault ? ` (${dayLabel(companyDefault)})` : ''}</option>
      {WEEKDAYS.map((d) => <option key={d} value={d}>{dayLabel(d)}</option>)}
    </select>
    <p className="text-[11px] text-slate-500 mt-1">Rest-day overtime rates (0.5 / 1.0 × ORP, 2.0 × HRP) apply only on this day.</p>
  </div>
  );
};
